import React, { forwardRef, useId } from 'react';
import { ChevronDown } from 'lucide-react';
import Field, { errorId, hintId } from '../Field/Field';
import { cx, describedBy } from '../utils';
import './Select.css';

// Variantlar children (<option>) orqali yoki options=[{ value, label, disabled }] orqali beriladi.
// placeholder berilsa, value="" bo'lgan birinchi option sifatida qo'shiladi.
const Select = forwardRef(function Select(
  {
    id,
    label,
    hint,
    error,
    options,
    placeholder,
    disabled,
    required,
    className,
    wrapperClassName,
    children,
    'aria-describedby': ariaDescribedBy,
    ...rest
  },
  ref
) {
  const autoId = useId();
  const selectId = id || autoId;

  return (
    <Field
      id={selectId}
      label={label}
      hint={hint}
      error={error}
      required={required}
      className={wrapperClassName}
    >
      <div className={cx('ui-control', error && 'ui-control--invalid')}>
        <select
          {...rest}
          ref={ref}
          id={selectId}
          disabled={disabled}
          required={required}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy(
            error ? errorId(selectId) : hint && hintId(selectId),
            ariaDescribedBy
          )}
          className={cx('ui-control__field', 'ui-select', className)}
        >
          {placeholder !== undefined && <option value="">{placeholder}</option>}
          {options
            ? options.map((option) => (
                <option key={String(option.value)} value={option.value} disabled={option.disabled}>
                  {option.label}
                </option>
              ))
            : children}
        </select>
        <span className="ui-control__icon ui-control__icon--right" aria-hidden="true">
          <ChevronDown />
        </span>
      </div>
    </Field>
  );
});

export default Select;
